import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { BehaviorSubject, combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-sortable-table-column-header',
  templateUrl: './sortable-table-column-header.component.html',
  styleUrls: ['./sortable-table-column-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SortableTableColumnHeaderComponent implements OnChanges {
  @Input() odataSortProperty: string = '';
  @Input() columnName: string = '';
  @Input() sortString: string = '';
  @Input() justifyColumnName: string = 'start';
  @Output() updateActiveSort: EventEmitter<string> = new EventEmitter();

  private _activeSort = new BehaviorSubject<string>('');
  public readonly activeSort$ = this._activeSort.asObservable();

  public isAscSort$ = this.activeSort$.pipe(map(sort => sort === `${this.odataSortProperty} asc`));
  public isDescSort$ = this.activeSort$.pipe(map(sort => sort === `${this.odataSortProperty} desc`));

  public sortIconSrc$ = combineLatest([this.isAscSort$, this.isDescSort$]).pipe(
    map(([isAsc, isDesc]) => {
      if (isAsc) {
        return 'assets/icons/white/Arrow Up.svg';
      } else if (isDesc) {
        return 'assets/icons/white/Arrow Down.svg';
      }
      return 'assets/icons/blue/Arrow Down.svg';
    })
  );

  public toggleSort(): void {
    combineLatest([this.isAscSort$, this.isDescSort$]).once(([isAsc, isDesc]) => {
      if (isDesc) {
        this.updateActiveSort.emit('');
      } else if (isAsc) {
        const newSort = `${this.odataSortProperty} desc`;
        this.updateActiveSort.emit(newSort);
      } else {
        const newSort = `${this.odataSortProperty} asc`;
        this.updateActiveSort.emit(newSort);
      }
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.sortString) {
      this._activeSort.next(this.sortString);
    }
  }
}
